// NOTE: Please format dates like YYYY-MM-DD
export const lumiereVideos = [
    {
        name: "FLASH DT IMPULSE: Fortitude | StuyLumière",
        date: "2024-04-28",
        videoLink: "https://www.youtube.com/embed/siiiBAaj5Vg"
    },
    {
        name: "StuyFlow | POHSHOW XVI | Virtual",
        date: "2022-04-28",
        videoLink: "https://www.youtube.com/embed/TtpG6uR1cdM"
    },
    {
        name: "StuyLumiere Season 3",
        date: "2021-04-16",
        videoLink: "https://www.youtube.com/embed/1qr7kVcvOJw"
    },
    {
        name: '"Breathe" | StuyFlow x Passive House 2020',
        date: "2020-06-26",
        videoLink: "https://www.youtube.com/embed/4do-bqTdBdQ",
    },
    {
        name: 'Lumiere Season 1 | SOS Performance',
        date: "2019-06-11",
        videoLink: "https://www.youtube.com/embed/xLej9FH0PQw?start=1676",
    },
]